import React from 'react'
import {Link} from 'react-router-dom'
import earth from "../img/about.png"
import { HashLink } from 'react-router-hash-link'

import './Component.css'
import './front_rwd.css'

class Front extends React.Component{
    render(){
        return(
            <Link to='/hi'>
            <div id='front-wrapper'>
                <Link to='/hi'>
                <h1 id="whoami">
                    Hello, I'm Vivian!<br/>
                    I'm a designer and HCI researcher :)
                </h1>
                <div id="front-button-wrapper">
                <div className="front-button"><h4>click anywhere!</h4></div>
                </div>
                {/*}
                <div id="front-button-wrapper">

                        <div className="front-button"><h2>I love to create ... </h2></div>
                */}
                </Link>
                    
                    
                    {/*<div className="front-button"><a className="list-link" href={pdf} target="_blank"><h2>CV</h2></a></div>*/}

                {/*
                <div id="button-wrapper">
                    <div className="little-thing">
                        <Link to='/aboutme'>
                            <div className="front-button"><h2>About Me</h2></div>
                        </Link>
                        <div className="front-little"></div>
                    </div>
                    
                    <div className="little-thing">
                        <Link to='/projects'>
                            <div className="front-button"><h2>Projects</h2></div>
                        </Link>
                        <div className="front-little"></div>
                    </div>
                    <div className="little-thing">
                        <div className="front-button"><h2>CV</h2></div>
                        <div className="front-little"></div>
                    </div>
                    
                </div>
                */}
                <div id="front">
                    <div id="earth">
                        <img src={earth} />
                    </div>
                </div>

                
            </div>
            </Link>
        )
    }
}



export default  Front